import { QueryClient, QueryClientConfig } from 'react-query';
import _ from 'scbk-services/utils/lodash-extension';
import { v7 } from 'uuid';

class QueryClientManager {
    private static client: QueryClient | null = null;

    private constructor() {}

    public static getQueryClient(): QueryClient {
        const config: QueryClientConfig = {
            defaultOptions: {
                mutations: {
                    onSuccess: (data: any) => {
                        const url = data?.config?.url ?? v7();
                        const key = url.split('/').filter(Boolean);
                        this.client?.setQueryData(key, data);
                        this.client?.invalidateQueries(key);
                    },
                    onError: (data: any) => {
                        //console.log('getQueryClient > defaultOptions > onError : ', data);
                        const url = data?.config?.url ?? v7();
                        const key = url.split('/').filter(Boolean);
                        this.client?.setQueryData(key, data);
                        this.client?.invalidateQueries(key);
                    },
                },
            },
        };

        if (_.isEmpty(this.client)) {
            this.client = new QueryClient(config);
        }

        return this.client;
    }
}

export { QueryClientManager };
